module.exports = __webpack_public_path__ + "static/media/eek21.6e2f1bba.JPG";